import { GlobalStyles } from 'tss-react';
import theme from './index';

const GlobalStyle = () => (
  <GlobalStyles
    styles={{
      body: {
        height: '100%',
        backgroundColor: theme.palette.primary.dark,
        overflowY: 'hidden',
        margin: 0,
        ...theme.typography.body,
      },

      h1: {
        ...theme.typography.h1,
        margin: 0,
      },

      'h1.sub': {
        ...theme.typography.subh1,
        margin: 0,
      },

      h2: {
        ...theme.typography.h2,
        margin: 0,
      },

      'h2.sub': {
        ...theme.typography.subh2,
        margin: 0,
      },

      h3: {
        ...theme.typography.h3,
        margin: 0,
      },

      'h3.sub': {
        ...theme.typography.subh3,
        margin: 0,
      },

      h4: {
        ...theme.typography.h4,
        margin: 0,
      },

      'h4.sub': {
        ...theme.typography.subh4,
        margin: 0,
      },

      h5: {
        ...theme.typography.h5,
        margin: 0,
      },

      h6: {
        ...theme.typography.h6,
        margin: 0,
      },

      'p, li': {
        ...theme.typography.body,
      },

      'p.highlight1': {
        ...theme.typography.highlight1,
      },

      'p.highlight2': {
        ...theme.typography.highlight2,
      },

      'h1, h2, h3, h4, h5, h6, body, p, li': {
        color: theme.palette.background.contrastText,
      },

      '@media(max-width: 450px)': {
        '.grecaptcha-badge': {
          visibility: 'hidden',
        },
      },

      /* Remove arrows from input fields */
      /* Chrome, Safari, Edge, Opera */
      'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
      /* Firefox */
      'input[type=number]': {
        '-moz-appearance': 'textfield',
      },

      '& div.MuiPaper-root': {
        backgroundImage: 'none',
      },
    }}
  />
);
export default GlobalStyle;
